import { render, staticRenderFns } from "./ExportSettings.vue?vue&type=template&id=0a131bf7&"
import script from "./ExportSettings.vue?vue&type=script&lang=js&"
export * from "./ExportSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports